import React from 'react';

const StatusBadge = ({ status, children }) => {
  const colors = {
    active: 'bg-green-100 text-green-700',
    inactive: 'bg-red-100 text-red-700',
    pending: 'bg-yellow-100 text-yellow-700',
    suspended: 'bg-orange-100 text-orange-700',
    deactivated: 'bg-orange-100 text-orange-700',
    offboarded: 'bg-gray-200 text-gray-600',
    staged: 'bg-blue-100 text-blue-700',
    default: 'bg-gray-100 text-gray-700',
  };

  const colorClass = colors[status?.toLowerCase()] || colors.default;

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${colorClass}`}>
      {children || status}
    </span>
  );
};

export default StatusBadge;
